import { axiosFactory } from "../common/axiosFactory";

export default async function initializeApp(getNewAccessTokenFunction) {
    axiosFactory.setGetNewAccessToken(getNewAccessTokenFunction);
}
